

var the_news = $('.newsList');
var newsList_class_count = 0;

the_news.each(function() {

        var sourceUrl = $(this).children('.sourceUrl');
        var articleCount = $(this).children('.articleCount');
        var showFeatureImage = $(this).children('.showFeatureImage');
        var articleLayout = $(this).children('.articleLayout');
        var showExcerpt = $(this).children('.showExcerpt');
        var hideArticleDate = $(this).children('.hideArticleDate');
        
        populateNews(sourceUrl.val(), articleCount.val(), showFeatureImage.val(), articleLayout.val(), showExcerpt.val(), hideArticleDate.val(), this);

});

function populateNews(sourceUrl, articleCount, showFeatureImage, articleLayout, showExcerpt, hideArticleDate, that) {

    var feedUrl = sourceUrl;
    var count = articleCount;
    var layout = articleLayout;
    var parametersUrl = "?json=get_recent_posts&count=" + count;
    var showFeatureImage = showFeatureImage;
    var showExcerptChecked = showExcerpt;
    var hideArticleDate = hideArticleDate;


    //Set the feed URL
    feedUrl = feedUrl + parametersUrl;

    $.ajax({
            method: "GET",
            url: feedUrl,
            headers: {}
        }).done(function (data) {
            var news = data.posts;
            var dataToProvide;


            //apply layout class to main wrapper
            if ( layout == 'standardLayout') {
                var newsTemplate = $('.newsStandard').first().text();        
            }
            else {
                var newsTemplate = $('.newsOverlay').first().text();
            }


            var compiledNewsTemplate = doT.template(newsTemplate);
        
            for (var i = 0; i < data.count; i++) {
                dataToProvide = news[i];
                dataToProvide.newsUrl = dataToProvide.url;
                dataToProvide.date = new Date(moment(dataToProvide.date));
                dataToProvide.date_day = moment(dataToProvide.date).format('DD');
                dataToProvide.date_month = moment(dataToProvide.date).format('MMM');
                dataToProvide.date_year = moment(dataToProvide.date).format('YYYY');
                dataToProvide.date_time = moment(dataToProvide.date).format('h:mm a');
                dataToProvide.news_title = dataToProvide.title;
                dataToProvide.news_excerpt = dataToProvide.excerpt;
                
                //Does the news have a feature image and is the show feature dialogue checked.
                if (dataToProvide.hasOwnProperty("thumbnail_images") && showFeatureImage == 'showFeature') {
                   dataToProvide.bgImage = dataToProvide.thumbnail_images.full.url;
                   dataToProvide.overlay ='news_overlay';
                   if ( layout == "standardLayout") {
                        dataToProvide.buttonStyle = 'classic_white_button_navy_border__small';  
                   }
                   else {
                        dataToProvide.buttonStyle = 'classic_transparent_button_white_border__small';
                   }
                   
                }
                else {
                    dataToProvide.bgImage = '';
                    dataToProvide.overlay = '';
                    dataToProvide.buttonStyle = 'classic_white_button_navy_border__small';                   
                }

                // Is show excertp checked?
                if (showExcerptChecked == 'showExcerpt') {
                    dataToProvide.show_excerpt ='news_show_excerpt';
                }
                else {
                    dataToProvide.show_excerpt ='hidden';                   
                }
                
                // Choose the column layout based on the number of articles selected to display.
                dataToProvide.column_layout = 'col-md-12 col-lg-4';
                if (count == '1') {
                    dataToProvide.column_layout = 'col-lg-12';
                }
                else if (count == '2'){
                    dataToProvide.column_layout = 'col-sm-12 col-md-6';
                }
                else if (count == '4'){
                    dataToProvide.column_layout = 'col-sm-12 col-md-6 col-lg-3';
                }

                //hide the article date
                if (hideArticleDate == 'hideArticleDate') {
                    dataToProvide.hide_date = 'hidden';
                }

                $(that).append(compiledNewsTemplate(dataToProvide));

            }

            $('.news_excerpts_line').ellipsis({
                lines: 3,             // force ellipsis after a certain number of lines. Default is 'auto'
                responsive: true      // set to true if you want ellipsis to update on window resize. Default is false
            });

            $('.news_overlay_excerpts_line').ellipsis({
                lines: 2,             // force ellipsis after a certain number of lines. Default is 'auto'
                responsive: true      // set to true if you want ellipsis to update on window resize. Default is false
            });

            $('.news_title h3').ellipsis({
                lines: 2,             // force ellipsis after a certain number of lines. Default is 'auto'
                responsive: true      // set to true if you want ellipsis to update on window resize. Default is false
            });
        });

}





